import React from 'react';
import {
    LinearProgress,
    Table,
    TableBody,
    TableContainer,
} from '@mui/material';
import useTranslate from '../../../../customHooks/useTranslate';
import Card from '../../../../muiComponents/Card';
import ContractRow from './ContractRow';
import TableHeader from '../../../../Table/TableHeader';
import { useContractsList } from '../../../contextsProperty/ContextContractsList';
import { contractsTableColumns } from '../../../../utils/contractUtils/contractsListUtils';

const ContractsTable = () => {
    const { items, isLoading, sortDir, sortedBy, sortByField, handleScroll } =
        useContractsList();
    const translate = useTranslate();

    return (
        <Card className='flex-column flex-grow min-height-0'>
            <TableContainer
                className=' flex-grow min-height-0 overflow-y-auto overflow-x-hidden'
                onScroll={handleScroll}
            >
                <Table stickyHeader size='small'>
                    <TableHeader
                        headerColumns={contractsTableColumns}
                        sortedBy={sortedBy}
                        sortDir={sortDir}
                        sortByField={sortByField}
                        isLoading={isLoading}
                        selectable={false}
                    />
                    <TableBody>
                        {items.map(item => (
                            <ContractRow key={item.Id} contract={item} />
                        ))}
                    </TableBody>
                    {items.length === 0 && (
                        <caption className='no-results'>
                            {isLoading && <LinearProgress />}
                            {items.length === 0 &&
                                !isLoading &&
                                translate('no_results')}
                        </caption>
                    )}
                </Table>
            </TableContainer>
        </Card>
    );
};

export default ContractsTable;
